
import React, { useEffect } from "react";
import { useSelector } from 'react-redux';
import {  useNavigate } from "react-router-dom";
import NavBar from "../../componenets/navbar/NavBar";
import UserList from "../../componenets/users/UserList";

const Users = () =>{
    const role = useSelector((state) => state.user.userDetails.UserRole);
    const navigate = useNavigate();
    // user check
    useEffect(()=>{
        if(role && role === "User"){
            navigate("/"); 
        }
    },[role, navigate]);
    
    const navActive = useSelector((state) => state.navActive.value);
    useEffect(() => {
        const bodypd = document.getElementById('cbody');
        (navActive) ?  bodypd.classList.add('body-pd') : bodypd.classList.remove('body-pd');
    }, [navActive]);

    return(<>
        <NavBar />
        <div id="cbody" className="cbody">
            <div className="concard">
                <UserList />
            </div>
        </div>
    </>);
};

export default Users;